
import { IEntityMetaData, IPropretyAttribute } from "../../../_models/IEntityMetaData";
import { PropretyAttributes, NestedProperty } from "../../../decorators/EntityDecorators";
import { EmployeePresenceTemplate } from "../EmployeePresenceTemplate.model";
import { Employee } from "../Employee.model";
import { GenericEntityBase } from "../../../_models/GenericEntityBase";

export class EmployeePresenceTemplate_Employee extends GenericEntityBase<string> {
  private _id?: string = undefined; 
  override get id(): string {
    if (this._id == null) {
      this._id = `${this.fK_EmployeePresenceTemplate}-${this.fK_Employee}`; 
    }
    return this._id;
  }

  override _isRelationEntity = true; 

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_EmployeePresenceTemplate!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_Employee!: number;

  @NestedProperty({ TargetType: EmployeePresenceTemplate })
  employeePresenceTemplate?: EmployeePresenceTemplate;

  @NestedProperty({ TargetType: Employee })
  employee?: Employee;

  GetType(): IEntityMetaData {
    return EmployeePresenceTemplate_Employee.getMetaData();
  }
}
